import * as React from "react";
export function SvgSpacesMediumDsCertified(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <circle cx={16.5} cy={17.5} r={3.5} fill="#4cbd93" />
      <path
        d="M18.5 16c-.2-.1-.4-.1-.6.1L16.4 18l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
        fill="#fff"
      />
      <path
        d="M18 7c0-1.7-2.7-3-6-3S6 5.3 6 7v11.4c0 1.4 2.7 2.6 6 2.6v-1c-3.2 0-5-1.1-5-1.6V8.7c1.1.8 2.9 1.3 5 1.3s3.9-.5 5-1.3V13h1V7zm-6 2C8.9 9 7 7.8 7 7s1.9-2 5-2 5 1.2 5 2-1.9 2-5 2z"
        fill="#676767"
      />
    </svg>
  );
}
